import { Injector } from '@angular/core';

export class AppLocator {
	public static injector: Injector;

	public static inject<T>(token: any): T {
		return <T>AppLocator.injector.get(token);
	}
}
